import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import batchGochiChargeStatuses from '../../constants/BatchGochiChargeStatuses';

const styles = {
  root: {
    backgroundColor: '#fff'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  headerLabel: {
    fontWeight: '500'
  },
  overflow: {
    overflow: 'auto'
  },
  error: {
    width: '50px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      listBatchGochiCharge: state.gochis.listBatchGochiCharge
        ? state.gochis.listBatchGochiCharge.list
        : [],
      totalCount: state.gochis.listBatchGochiCharge
        ? state.gochis.listBatchGochiCharge.count
        : 0
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('checked', 'setChecked', () => {
    return new Map();
  }),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    listBatchGochiCharge,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    setRowsPerPage
  }) => {
    return (
      <div className={classes.root}>
        <div>
          <div className={classes.buttonContainer} />
          <div className={classes.scrollTable}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>一括チャージID</TableCell>
                  <TableCell>チャージ履歴ID</TableCell>
                  <TableCell>領収書NO</TableCell>
                  <TableCell>チャージ金額</TableCell>
                  <TableCell>利用開始</TableCell>
                  <TableCell>利用期限</TableCell>
                  <TableCell>インポート日時</TableCell>
                  <TableCell>実施日時</TableCell>
                  <TableCell>ステータス</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listBatchGochiCharge &&
                  listBatchGochiCharge.map(listGochi => (
                    <TableRow key={listGochi.gochiChargeBatchRequestId}>
                      <TableCell>{listGochi.batchLogId}</TableCell>
                      <TableCell>{listGochi.gochiChargeLogId}</TableCell>
                      <TableCell>{listGochi.gochiBillNo}</TableCell>
                      <TableCell>{listGochi.premiumAmount}</TableCell>
                      <TableCell>{listGochi.useStartAt}</TableCell>
                      <TableCell>{listGochi.useEndAt}</TableCell>
                      <TableCell>{listGochi.createdAt}</TableCell>
                      <TableCell>{listGochi.executeDate}</TableCell>
                      <TableCell>
                        {batchGochiChargeStatuses.map(item => {
                          return item.value === listGochi.status
                            ? item.name
                            : '';
                        })}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>

          <ExPaginationGroup
            count={
              totalCount % rowsPerPage > 0
                ? Math.floor(totalCount / rowsPerPage) + 1
                : Math.floor(totalCount / rowsPerPage)
            }
            selectedPage={page}
            handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
            limit={rowsPerPage}
            totalCount={totalCount}
            setLimit={setRowsPerPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
